<template>
  <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'">
    <InternalTransOutTabTable></InternalTransOutTabTable>
  </v-card>
</template>
<script>
import InternalTransOutTabTable from "./InternalTransOutTabTable.vue";

export default {
  components: {
    InternalTransOutTabTable,
  },
};
</script>
